jQuery(document).ready(function($){
	if ( itr.current_page == "welcome" || itr.video_archive == 1 ){
		$('#closePlayerAction').on('click', function(event){
			event.preventDefault();
			$('#modalPlayer').addClass('unfix');
			$('#modalPlayer').removeClass('fixed');
			$('#videoFrame').attr('src', '');
		});
		$('.modalVideoTrigger').on('click', function(event){
			event.preventDefault();
			$('#modalPlayer').addClass('fixed');
			$('#modalPlayer').removeClass('unfix');
			var videoID = $(this).data('video-id');
			$('#videoFrame').attr('src', 'https://www.youtube.com/embed/' + videoID +'?rel=0');
		});
	};
});